var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 43,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.48 17.477v7.313H51.91v-5.141h-2.475v5.14h-2.568v-7.312h7.617-.006zM45.606 21.545c0 2.14-1.774 3.55-4.159 3.55-2.384 0-4.281-1.5-4.281-4.861 0-2.903 1.836-5.294 4.586-5.324 1.195 0 3.763-.061 3.763-.061l-1.165 2.14h-2.324c-1.225 0-2.232.885-2.415 2.11a3.689 3.689 0 0 1 2.477-.945c2.201 0 3.518 1.348 3.518 3.397v-.006zm-2.659 0c0-.945-.61-1.5-1.5-1.5s-1.53.58-1.53 1.53c0 .885.61 1.562 1.53 1.562.921 0 1.5-.732 1.5-1.592zM35.117 22.581a3.976 3.976 0 0 1-1.561.427c-1.073.03-2.019-.64-2.019-1.805s.854-1.805 1.988-1.805c.702 0 1.653.487 1.653.487s.67-1.225 1.043-1.835c-.732-.519-1.622-.762-2.537-.732-2.537 0-4.525 1.622-4.525 3.915s1.866 3.885 4.525 3.855c.732-.031 1.775-.275 2.385-.671l-.946-1.836h-.006z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2.205 12.982 3.58 6.33v3.885l-3.55 6.33-.03-16.545z",
    fill: "#5B57A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.907 17.02 3.336-2.05h6.849l-10.185 6.21v-4.16z",
    fill: "#D90751"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15.877 12.952.03 8.38-3.58-2.172V6.585l3.55 6.367z",
    fill: "#FAB718"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.092 14.97h-6.849l-3.366-2.018-3.55-6.367 13.765 8.385z",
    fill: "#ED6F26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.908 29.588V25.49l-3.58-2.14v12.569l3.58-6.33z",
    fill: "#63B22F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.243 27.539 5.784 19.312l-3.58-6.33L26.062 27.54h-6.818z",
    fill: "#1487C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.328 35.918 3.58-6.33 3.335-2.05h6.819l-13.734 8.38z",
    fill: "#017F36"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.235 29.528 12.36 23.35l-3.39-2.08-3.184 1.928-3.55 6.33z",
    fill: "#984995"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.4cfa292a036dd5f5b3c2def6b10f6939.svg";
export { ForwardRef as ReactComponent };